import type * as Types from '../../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { MpFieldsFragmentDoc } from '../../../../graphql/gql-fragments/meeting-participant.graphql';
import { IdentityFieldsFragmentDoc } from '../../../../graphql/gql-fragments/identity.graphql';
import { MeetingValidatorErrorFieldsFragmentDoc } from '../../../../graphql/gql-fragments/meeting.graphql';
import { FileFieldsFragmentDoc } from '../../../../graphql/gql-fragments/document.graphql';
import { MdFieldsFragmentDoc } from '../../../../graphql/gql-fragments/meeting-document.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlParticipantsSummonsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  meetingId: Types.Scalars['ID']['input'];
  filter?: Types.InputMaybe<Types.GqlMeetingParticipantFilterInput>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GqlParticipantsSummonsQuery = { meetingParticipants: { totalCount: number, models: Array<{ id: string, initials?: string | null, chairman: boolean, secretary: boolean, adjuster: boolean, present: boolean, summoned?: boolean | null, position?: string | null, isShareholder: boolean, kind: Types.GqlMpKind, proxyId?: string | null, meetingId?: string | null, identityId: string, createdAt: string, updatedAt: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, proxy?: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } | null, latestMeetingParticipantEmail?: { id: string, fileId: string, email: { id: string, toEmail: string, emailStatus?: Types.GqlEmailStatus | null, emailFailReason?: string | null, emailSimplifiedState: Types.GqlEmailSimplifiedState, jobState: Types.GqlJobState } } | null }> } };

export type GqlMeetingErrorsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlMeetingErrorsQuery = { meetingErrors: { details: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, agenda: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, postalVote: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, language: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, participants: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, summons: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, protocol: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, votingList: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, emailSummons: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, registerAttendance: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null } } };

export type GqlDocGenerateMeetingSummonsDirectMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  meetingId: Types.Scalars['ID']['input'];
}>;


export type GqlDocGenerateMeetingSummonsDirectMutation = { docGenerateMeetingSummonsDirect: { id: string, companyId: string, mimeType: string, filename: string, filesize?: number | null, sha256?: string | null, signedFilesize?: number | null, signedSha256?: string | null, signatureMethod?: Types.GqlDocumentSignatureMethod | null, dirty: boolean, scriveMtime?: string | null, scriveCtime?: string | null, scriveStatus?: Types.GqlScriveDocumentStatus | null, scriveParties?: any | null, scriveTimeoutTime?: string | null, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null, signAllowedAction: Types.GqlSignAllowedAction, hasSignStatus: boolean, hasThumbnail: boolean, kind: Types.GqlDocSystemTagKind, groupId?: string | null, userTags?: Array<string> | null, genState: Types.GqlDocGenState, uploaded: boolean, reminderSentAt?: string | null, deletable: boolean, softDeletable: boolean, createdAt: string, updatedAt: string, sharedWithShareholders: boolean, meetingDocument?: { id: string, fileId: string, meetingId: string, createdAt: string, updatedAt: string } | null } };


export const ParticipantsSummonsDocument = gql`
    query ParticipantsSummons($companyId: ID!, $meetingId: ID!, $filter: MeetingParticipantFilterInput, $offset: Int, $limit: Int) {
  meetingParticipants(
    companyId: $companyId
    meetingId: $meetingId
    filter: $filter
    offset: $offset
    limit: $limit
  ) {
    totalCount
    models {
      ...MpFields
      identity {
        ...IdentityFields
      }
      proxy {
        ...IdentityFields
      }
      latestMeetingParticipantEmail {
        id
        fileId
        email {
          id
          toEmail
          emailStatus
          emailFailReason
          emailSimplifiedState
          jobState
        }
      }
    }
  }
}
    ${MpFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;

/**
 * __useParticipantsSummonsQuery__
 *
 * To run a query within a React component, call `useParticipantsSummonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantsSummonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantsSummonsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      meetingId: // value for 'meetingId'
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useParticipantsSummonsQuery(baseOptions: Apollo.QueryHookOptions<GqlParticipantsSummonsQuery, GqlParticipantsSummonsQueryVariables> & ({ variables: GqlParticipantsSummonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlParticipantsSummonsQuery, GqlParticipantsSummonsQueryVariables>(ParticipantsSummonsDocument, options);
      }
export function useParticipantsSummonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlParticipantsSummonsQuery, GqlParticipantsSummonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlParticipantsSummonsQuery, GqlParticipantsSummonsQueryVariables>(ParticipantsSummonsDocument, options);
        }
export function useParticipantsSummonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlParticipantsSummonsQuery, GqlParticipantsSummonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlParticipantsSummonsQuery, GqlParticipantsSummonsQueryVariables>(ParticipantsSummonsDocument, options);
        }
export type ParticipantsSummonsQueryHookResult = ReturnType<typeof useParticipantsSummonsQuery>;
export type ParticipantsSummonsLazyQueryHookResult = ReturnType<typeof useParticipantsSummonsLazyQuery>;
export type ParticipantsSummonsSuspenseQueryHookResult = ReturnType<typeof useParticipantsSummonsSuspenseQuery>;
export type ParticipantsSummonsQueryResult = Apollo.QueryResult<GqlParticipantsSummonsQuery, GqlParticipantsSummonsQueryVariables>;
export const MeetingErrorsDocument = gql`
    query MeetingErrors($companyId: ID!, $id: ID!) {
  meetingErrors(companyId: $companyId, id: $id) {
    ...MeetingValidatorErrorFields
  }
}
    ${MeetingValidatorErrorFieldsFragmentDoc}`;

/**
 * __useMeetingErrorsQuery__
 *
 * To run a query within a React component, call `useMeetingErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingErrorsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMeetingErrorsQuery(baseOptions: Apollo.QueryHookOptions<GqlMeetingErrorsQuery, GqlMeetingErrorsQueryVariables> & ({ variables: GqlMeetingErrorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMeetingErrorsQuery, GqlMeetingErrorsQueryVariables>(MeetingErrorsDocument, options);
      }
export function useMeetingErrorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMeetingErrorsQuery, GqlMeetingErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMeetingErrorsQuery, GqlMeetingErrorsQueryVariables>(MeetingErrorsDocument, options);
        }
export function useMeetingErrorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlMeetingErrorsQuery, GqlMeetingErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlMeetingErrorsQuery, GqlMeetingErrorsQueryVariables>(MeetingErrorsDocument, options);
        }
export type MeetingErrorsQueryHookResult = ReturnType<typeof useMeetingErrorsQuery>;
export type MeetingErrorsLazyQueryHookResult = ReturnType<typeof useMeetingErrorsLazyQuery>;
export type MeetingErrorsSuspenseQueryHookResult = ReturnType<typeof useMeetingErrorsSuspenseQuery>;
export type MeetingErrorsQueryResult = Apollo.QueryResult<GqlMeetingErrorsQuery, GqlMeetingErrorsQueryVariables>;
export const DocGenerateMeetingSummonsDirectDocument = gql`
    mutation DocGenerateMeetingSummonsDirect($companyId: ID!, $meetingId: ID!) {
  docGenerateMeetingSummonsDirect(companyId: $companyId, meetingId: $meetingId) {
    ...FileFields
    meetingDocument {
      ...MdFields
    }
  }
}
    ${FileFieldsFragmentDoc}
${MdFieldsFragmentDoc}`;
export type GqlDocGenerateMeetingSummonsDirectMutationFn = Apollo.MutationFunction<GqlDocGenerateMeetingSummonsDirectMutation, GqlDocGenerateMeetingSummonsDirectMutationVariables>;

/**
 * __useDocGenerateMeetingSummonsDirectMutation__
 *
 * To run a mutation, you first call `useDocGenerateMeetingSummonsDirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocGenerateMeetingSummonsDirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [docGenerateMeetingSummonsDirectMutation, { data, loading, error }] = useDocGenerateMeetingSummonsDirectMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useDocGenerateMeetingSummonsDirectMutation(baseOptions?: Apollo.MutationHookOptions<GqlDocGenerateMeetingSummonsDirectMutation, GqlDocGenerateMeetingSummonsDirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDocGenerateMeetingSummonsDirectMutation, GqlDocGenerateMeetingSummonsDirectMutationVariables>(DocGenerateMeetingSummonsDirectDocument, options);
      }
export type DocGenerateMeetingSummonsDirectMutationHookResult = ReturnType<typeof useDocGenerateMeetingSummonsDirectMutation>;
export type DocGenerateMeetingSummonsDirectMutationResult = Apollo.MutationResult<GqlDocGenerateMeetingSummonsDirectMutation>;
export type DocGenerateMeetingSummonsDirectMutationOptions = Apollo.BaseMutationOptions<GqlDocGenerateMeetingSummonsDirectMutation, GqlDocGenerateMeetingSummonsDirectMutationVariables>;